/**
 * @generated SignedSource<<49a10984f44144766f42242d334ee1ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStepDeliveryView_transaction$data = {
  readonly sku: {
    readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_sku">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PreQuoteTitle_transaction">;
  readonly " $fragmentType": "CheckoutReviewStepDeliveryView_transaction";
};
export type CheckoutReviewStepDeliveryView_transaction$key = {
  readonly " $data"?: CheckoutReviewStepDeliveryView_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStepDeliveryView_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStepDeliveryView_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PreQuoteTitle_transaction"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PreQuoteTitle_sku"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "36d753cfd2ec94cfb1e57ddbfc28c7f8";

export default node;
